module.exports = "<div class=\"temp-account-message cgp-themes-main-text\">{message | inject}</div>";